import { useQuery } from "@tanstack/react-query";
import invariant from "shared/utils/invariant";
import { queryClient } from "../../../shared/api/queryClient";
import { getPageModuleDetails } from "../api/getPageModuleDetails";

type Params = { moduleId: string | null; brandId: string; pageId: string };

export const usePageModuleDetailsQuery = ({
  moduleId,
  brandId,
  pageId,
}: Params) => {
  return useQuery({
    queryKey: ["pageModuleDetails", { moduleId, pageId, brandId }],
    queryFn: async () => {
      invariant(moduleId);
      return await getPageModuleDetails({
        moduleId,
        pageId,
        brandId,
      });
    },
    staleTime: 0,
  });
};

export const invalidatePageModuleDetails = async ({
  moduleId,
  brandId,
  pageId,
}: Params) => {
  await queryClient.invalidateQueries({
    queryKey: ["pageModuleDetails", { moduleId, pageId, brandId }],
  });
};
